import React from 'react';
interface PhoneFrameProps {
  children: React.ReactNode;
  label: string;
  /** Sizing utilities for the device. Defaults to a fixed mobile size. */
  sizeClassName?: string;
  className?: string;
}

/**
 * Device shell for the mobile Snak. The screen scrolls on its own so the
 * prototype stays fully usable inside the presentation shell.
 */
export function PhoneFrame({
  children,
  label,
  sizeClassName = 'h-[688px] w-[344px]',
  className = ''
}: PhoneFrameProps) {
  return <div className={['relative shrink-0 rounded-[52px] bg-[#0B1512] p-[12px]', 'shadow-[0_60px_110px_-50px_rgba(1,51,43,0.55)]', sizeClassName, className].join(' ')} role="group" aria-label={label} data-id="element-503" data-mp="2blavbpjhcfxu">
      {/* side buttons */}
      <span aria-hidden="true" className="absolute -left-[3px] top-[152px] h-14 w-[3px] rounded-l-full bg-[#0B1512]" data-id="element-504" data-mp="m6mk3rmml41e" />
      <span aria-hidden="true" className="absolute -left-[3px] top-[222px] h-14 w-[3px] rounded-l-full bg-[#0B1512]" data-id="element-505" data-mp="r6sh7nbnziqv" />
      <span aria-hidden="true" className="absolute -right-[3px] top-[186px] h-20 w-[3px] rounded-r-full bg-[#0B1512]" data-id="element-506" data-mp="38ym8akrgz0bs" />

      <div className="relative h-full w-full overflow-hidden rounded-[42px] bg-[#FBF7F0]" data-id="element-507" data-mp="2z66rvrvtmjt0">
        <span aria-hidden="true" className="absolute left-1/2 top-2.5 z-20 h-[18px] w-[78px] -translate-x-1/2 rounded-full bg-[#0B1512]" data-id="element-508" data-mp="2v5wjk8kk3haz" />
        <div className="no-scrollbar h-full w-full overflow-y-auto overscroll-contain" data-id="element-509" data-mp="3rt9ky4hqa2bv">
          {children}
        </div>
      </div>
    </div>;
}